import React, { useState } from "react";
import ScrollReveal from "./ScrollReveal";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";

const About = () => {
  const { language } = useLanguage();

  return (
    <div className="about-container" id="about-container">
      <div className="section-title">
        {">  " + translations[language].sectionTitles.about}
      </div>
      <ScrollReveal delay={0.5}>
        <div className="about-description-container">
          <div className="about-user-image"></div>
          <div className="about-user-text">
            {translations[language].aboutMe}
          </div>
        </div>
      </ScrollReveal>
    </div>
  );
};

export default About;
